package de.oevbs.kunde.kundenportal2.services.intinscard

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.carContractsButtonToggleFormat
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.model.services.intinscard.*
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.intinscard.store.IntInsCardStore
import dev.fritz2.core.RenderContext
import dev.fritz2.core.invoke
import dev.fritz2.headless.validation.Severity
import kotlinx.coroutines.flow.combine

fun RenderContext.intInsCardStart() {

    val iicStore = IntInsCardStore(job)

    headerImageLayout {
        title("Internationale Versicherungskarte bestellen")
        content {
            renderSteps(iicStore)
        }
    }
}

private fun RenderContext.renderSteps(iicStore: IntInsCardStore) {

    iicStore.currentStep.render { step ->

        GlobalServiceMessagesStore.clear()

        when (step) {
            GeneralProgressStep.SUBMIT1 -> intInsCardStep1(iicStore)
            GeneralProgressStep.SUCCESS2 -> {
                val selectedContractSub = iicStore.map(IntInsCardInit.selectedContract())
                messagePagePre(
                    header = "Erfolgreich angefordert",
                    severity = Severity.Success,
                    preContent = PortalContactNotes.InternationalInsuranceCardSent(
                        selectedContractSub.current?.contractNumberPm ?: "",
                        selectedContractSub.current?.licencePlate ?: ""
                    ).note
                )
            }
        }
    }
}

fun RenderContext.intInsCardStep1(iicStore: IntInsCardStore) {
    contentContainer {
        iicStore.init()
        globalInitTracker.data.combine(iicStore.initFailedFlow, ::Pair).render { (loading, failed) ->
            if (loading) return@render
            when {
                failed -> noContractDataFoundMessage()
                else -> showUi(iicStore)
            }
        }
    }
}

fun RenderContext.showUi(iicStore: IntInsCardStore) {

    val selectedContractSub = iicStore.map(IntInsCardInit.selectedContract())
    val contractsSub = iicStore.map(IntInsCardInit.carContracts())

    contractsSub.data.render contractsList@{ contracts ->
        if (contracts.isEmpty()) {
            messageCardWithContent(
                "Sie haben kein Fahrzeug bei uns versichert. Möchten Sie das ändern? Melden Sie sich bei Ihrer Beraterin oder Ihrem Berater."
            ) {
                btn {
                    label("Mitteilung schreiben")
                }.clicks handledBy { Pages.contactMessage.visit() }
            }
            return@contractsList
        }


        paragraph {
            +"Bei einer Auslandsreise mit Ihrem Fahrzeug benötigen Sie in einigen Ländern die sogenannte Grüne Versicherungskarte –"
            +" die internationale Versicherungskarte für den Kraftverkehr – als Gültigkeitsnachweis für einen bestehenden Versicherungsschutz."
            +" Ist Ihr Fahrzeug bei uns versichert, können Sie die internationale Versicherungskarte hier kostenlos bestellen und sie wird"
            +" Ihnen "
            b { +"in den nächsten 3 bis 5 Tagen per Post zugestellt." }
        }

        sectionHeader("Vertrag auswählen")

        card {
            buttonToggleKupo<CarContract?> {
                value.single(selectedContractSub)
                options = contractsSub.current
                optionsFormat = carContractsButtonToggleFormat
            }
        }

        selectedContractSub.data.renderNotNull { selectedContract ->
            card {
                paragraph {

                    +"Die internationale Versicherungskarte für das Fahrzeug "
                    br {}
                    b {
                        +"${selectedContract.branchGroup}, ${selectedContract.licencePlate} (${selectedContract.contractNumberPm})"
                    }
                    br {}
                    +" erhalten Sie per Post an Ihre im Vertrag hinterlegte Adresse:"
                }

                h5 {
                    +"${iicStore.map(IntInsCardInit.firstname()).current} ${iicStore.map(IntInsCardInit.lastname()).current}"
                    br {}
                    +"${iicStore.map(IntInsCardInit.street()).current} ${iicStore.map(IntInsCardInit.streetNumber()).current}"
                    br {}
                    +"${iicStore.map(IntInsCardInit.postalCode()).current} ${iicStore.map(IntInsCardInit.city()).current}"
                }
            }
        }

        buttonContainer {
            btn {
                label("Anfordern")
                busy(globalSubmitTracker.data)
            }.clicks handledBy iicStore.requestIntInsCard
        }
    }
}